module.exports = __webpack_public_path__ + "static/media/RAGAD TUTANJI.e07a1976.png";